module.exports = __webpack_public_path__ + "img/xvg.f7d3bc42.svg";